import { render, staticRenderFns } from "./EnvironmentError.vue?vue&type=template&id=b05a1d22&lang=pug&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b05a1d22')) {
      api.createRecord('b05a1d22', component.options)
    } else {
      api.reload('b05a1d22', component.options)
    }
    module.hot.accept("./EnvironmentError.vue?vue&type=template&id=b05a1d22&lang=pug&", function () {
      api.rerender('b05a1d22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnvironmentError.vue"
export default component.exports